import Axios from "axios";
import { useEffect, useState } from "react";
import GlobalConfig from "../config/GlobalConfig";

export function useGlobalConfig() {
  const [globalConfig, setGlobalConfig] = useState<{ [key: string]: any }>();

  useEffect(() => {
    const controller = new AbortController();

    GlobalConfig.get({ signal: controller.signal })
      .then((config) => {
        setGlobalConfig(config);
      })
      .catch((e: any) => {
        // Same contract as useConfig: an aborted read is silent, a failed one
        // stays visible in the console, and neither is an unhandled rejection
        // (which fails every jest test that renders a caller, H146).
        if (Axios.isCancel(e) || e?.name === "AbortError" || e?.name === "CanceledError") return;
        console.error("Global config query failed", e);
      });

    return () => {
      controller.abort();
    };
  }, []);

  return globalConfig;
}
